/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */

export type ZoomCloud = (typeof ZoomCloud)[keyof typeof ZoomCloud];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ZoomCloud = {
  commercial: 'commercial',
  government: 'government',
} as const;
